import { Center, Icon, Flex, Box } from '@chakra-ui/react';
import { MainLogoLarge } from '../../../assets/icons';
import { HiArrowNarrowLeft } from 'react-icons/hi';
import { ROUTERS } from '../../../data/routers';
import { useLocation } from 'react-router-dom';
import { CustomNavLink } from '../../Links/CustomNavLink';
import { useTranslation } from 'react-i18next';

export const AuthHeader = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isShowLinkToInitScreen = location.pathname !== ROUTERS.INIT;

  return (
    <Box as='header'>
      <Flex
        color='whiteAlpha.600'
        pt={2}
        pl={[0, 2]}
        justifyContent={['center', 'flex-start']}
        zIndex={isShowLinkToInitScreen ? 'initial' : -1}
        position='relative'
      >
        <Icon as={HiArrowNarrowLeft} mt='4px' mr={1} />
        <CustomNavLink to={ROUTERS.INIT} fontSize='sm'>
          {t('back.to.init.screen')}
        </CustomNavLink>
      </Flex>

      <Center mt={{ base: 0, lg: '2vh' }}>
        <Box maxW={{ base: '200px', sm: '300px', '2xl': 'initial' }} sx={{ svg: { maxH: '100%', w: '100%' } }}>
          <MainLogoLarge />
        </Box>
      </Center>
    </Box>
  );
};
